<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-container">
      <button class="modal-close" @click="$emit('close')">✕</button>

      <div class="modal-body">
        <h2 class="modal-title">{{ $t('health.NutritionistNotes.title') }}</h2>

        <div class="note-form">
          <h3 class="form-title">
            {{$t('health.NutritionistNotes.titleCreate') }}
          </h3>
          <div class="form-group" v-for="field in fields" :key="field">
            <label>{{ $t(`health.NutritionistNotes.${field}`) }}</label>
            <textarea v-model="form[field]" rows="2" />
          </div>
          <div class="form-actions">
            <button class="btn btn-primary" @click="saveNote">
              {{$t('health.NutritionistNotes.create') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import nutritionistNotesApi from '../../api/nutritionistNotes';

const emptyForm = () => ({
  allergies: '',
  intolerances: '',
  preferences: '',
  food_dislike: '',
  supplements: '',
  additional_comment: ''
});

export default {
  name: 'NutritionistNotesModal',
  props: {
    patientId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      form: emptyForm(),
      fields: ['allergies', 'intolerances', 'preferences', 'food_dislike', 'supplements', 'additional_comment']
    };
  },
  methods: {

    saveNote() {
        nutritionistNotesApi.createNote(this, this.patientId, this.form)
          .then(() => { this.form = emptyForm(); this.$emit('saved'); this.$emit('close'); })
          .catch(error => console.error(error));
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/stylesheets/variables";

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba($black, 0.6);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  background: $white;
  border-radius: $radius;
  width: 500px;
  max-width: 95vw;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  padding: 1.5em;
}

.modal-close {
  position: absolute;
  top: 0.5em;
  right: 0.5em;
  background: $primary;
  color: $white;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  cursor: pointer;
  &:hover { background: $secondary; }
}

.modal-title {
  color: $primary;
  font-weight: bold;
  margin-bottom: 1.5em;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.25em;
  margin-bottom: 0.75em;

  textarea {
    border: 1px solid $black-light6;
    border-radius: $radius;
    padding: 0.5em;
    resize: vertical;
  }
}

.form-actions {
  display: flex;
  gap: 0.5em;
  margin-top: 1em;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/components/nutritionPlan/CreateNutritionistNoteModal.vue